import { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Meta from "../../components/Meta";
import Loading from "../../components/Loading";

import Data from '../../../repository';
import AppContext from "../../../context";

import styles from '../../../styles/Entry.module.scss';

const termsSchema = yup.object({
	acceptTerms: yup.boolean()
		.oneOf([true], 'You must accept the terms and conditions')
		.required('You must accept the terms and conditions')
});

function Terms() {
	const context = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);

	const {
		register,
		handleSubmit,
		formState: { errors },
		watch
	} = useForm({
		resolver: yupResolver(termsSchema),
		defaultValues: {
			acceptTerms: false
		}
	});

	const acceptTerms = watch('acceptTerms');

	const onSubmit = async () => {
		setLoading(true);
		setServerError(null);

		try {
			await Data.acceptTerms();
			window.location.href = '/';
		} catch (error) {
			setServerError(error.response?.data?.message || 'An error occurred. Please try again.');
			setLoading(false);
		}
	}

	return (
		<>
			<Meta title="Terms & Conditions" />

			<div className={styles.fullHeight}>
				{serverError &&
					<div className={styles.error}>
						<p>{serverError}</p>
					</div>
				}

				<h1>{context.domain.termsDocumentName}</h1>

				<div className={styles.terms} dangerouslySetInnerHTML={{ __html: context.domain.terms }} />

				<form onSubmit={handleSubmit(onSubmit)}>
					<div className={styles.actions}>
						<label className={styles.checkbox}>
							<input type="checkbox" {...register('acceptTerms')} />
							I have read and accept the {context.domain.termsDocumentName}
						</label>
						{errors.acceptTerms && <p className={styles.fieldError}>{errors.acceptTerms.message}</p>}
						<button type="submit" className="btn btnPrimary" disabled={!acceptTerms || loading}>
							{loading ?
								<Loading button={true} />
								:
								`Continue`
							}
						</button>
						<Link to="/entry/induction" className="btn btnEmpty">Back</Link>
					</div>
				</form>
			</div>
		</>
	);
}

export default Terms;
